/**
 * @classdesc 単位変換系のユーティリティクラス
 */
export default class ConvertUtils {

    /**
     * remをpxに変換
     * @param {number} rem - 変換するrem値
     * @returns {number} px単位の数値
     */
    static remToPx(rem) {
        const style = getComputedStyle(document.documentElement);

        return parseFloat(style.fontSize) * rem;
    }

    /**
     * pxをremに変換
     * @param {number} px - 変換するpx値
     * @returns {number} rem単位の数値
     */
    static pxToRem(px) {
        const style = getComputedStyle(document.documentElement);

        return px / parseFloat(style.fontSize);
    }
}
